import { render, staticRenderFns } from "./ContactBar.vue?vue&type=template&id=537ac828&scoped=true&"
import script from "./ContactBar.vue?vue&type=script&lang=js&"
export * from "./ContactBar.vue?vue&type=script&lang=js&"
import style0 from "./ContactBar.vue?vue&type=style&index=0&id=537ac828&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ac828",
  null
  
)

export default component.exports